module.exports = __webpack_public_path__ + "img/product-shot_07_loading.f52866a9.jpg";